// extracted by mini-css-extract-plugin
export var hidden = "RemoveButton-module--hidden--23a7a";
export var remove = "RemoveButton-module--remove--80242";